import { render } from "./penghargaan-list.vue?vue&type=template&id=0cd8facb"
import script from "./penghargaan-list.vue?vue&type=script&lang=js"
export * from "./penghargaan-list.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__